function checkAgreement(form) {
  var $form = $(form);
  var reqInputs = $form.find('.agreement');
  for (var i = 0; i < reqInputs.length; i++) {
    if (reqInputs.hasOwnProperty(i) && reqInputs[i].checked == false) {
      var span = $(reqInputs[i]).parent().find('span');

      if (span.length) {
        var message = 'Uděl ' + span.text().trim().toLowerCase() + '.';
      } else {
        var message =
          'Uděl ' +
          $(reqInputs[i]).parent().find('label').text().trim().toLowerCase() +
          '.';
      }

      showFlashMessage(2, message);

      // $form.find("button[type=submit]").before("<p class=\"form-status error\">"+message+"</p>");

      return false;
    }
  }

  return true;
}

function showFlashMessage(type, message) {
  alert(message);
  var $message = $('#js-message');
  switch (type) {
    case 1:
      type = 'success';
      break;
    case 2:
      type = 'error';
      break;
    default:
      type = '';
      break;
  }
  $message
    .removeAttr('class')
    .addClass('window-message')
    .removeClass('success')
    .removeClass('error')
    .addClass(type)
    .stop()
    .slideDown(300);
  $message.find('p').text(message);
  setTimeout(function () {
    $message.stop().slideUp(300);
  }, 2000);
}

function initAjaxForm($form) {
  $form.ajaxForm({
    beforeSubmit: function (arr, $form, options) {
      if (!checkAgreement($form)) {
        return false;
      }

      for (var i = 0; i < arr.length; i++) {
        if (arr[i].name == 'form[advert_id][]' && arr[i].value != '') {
          var parsed = JSON.parse(arr[i].value);
          for (var y = 0; y < parsed.length; y++) {
            arr.push({ name: 'form[advert_id][]', value: parsed[y] });
          }
          arr.splice(i, 1);
          break;
        }
      }
      // for(var i = 0;i < formAttr.length;i++){
      //   arr.push(formAttr[i]);
      // }
      arr.push({ name: 'form[secure_code]', value: '730405/2459' });
    },
    success: function (data) {
      var parsedData = JSON.parse(data.trim());

      if (parsedData.form.modal == 0) {
        $popup = $('#js-popup');
        $popup.removeClass('opened');
        $('body').removeClass('overflow');
      }

      showFlashMessage(parsedData.form.status, parsedData.form.message);

      if (
        typeof parsedData.replace !== 'undefined' &&
        parsedData.replace.url != '' &&
        parsedData.replace.url != null
      ) {
        setTimeout(function () {
          window.location = parsedData.replace.url;
        }, 3000);
      }

      if (parsedData.form.status === 1) {
        $form[0].reset();
      }
    },
  });
}

$(document).ready(function () {
  $('.async-form').each(function (i, element) {
    var $element = $(element);
    initAjaxForm($element);
  });
});
